import * as React from 'react';
import { EmailField } from '@doordash/component-fields';
import { QuestionSectionContainer } from '../QuizStyles';
export var EmailInputSection = function (_a) {
    var emailLabel = _a.emailLabel, _b = _a.emailValue, emailValue = _b === void 0 ? '' : _b, _c = _a.emailError, emailError = _c === void 0 ? '' : _c, onEmailChange = _a.onEmailChange;
    return (React.createElement(QuestionSectionContainer, null,
        React.createElement(EmailField, { label: emailLabel, value: emailValue, error: emailError, onChange: onEmailChange, autoFocus: true })));
};
